// src/plugins/dateFormatter.js
export default {
  install(Vue) {
    Vue.prototype.$formatDate = function(dateString, format = 'short') {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      
      const formats = {
        short: { 
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit' 
        },
        long: { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        },
        datetime: { 
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        },
        time: { 
          hour: '2-digit', 
          minute: '2-digit',
          hour12: false
        },
        full: {
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false  // ← Formato 24 horas
        }
      };
      
      return date.toLocaleDateString('es-PE', formats[format] || formats.short);
    };
    Vue.prototype.$setFechaEntrega = function() {

      const hoy = new Date();                      // Fecha actual
      const diaSemana = hoy.getDay();              // 0=Dom, 1=Lun ... 5=Vie, 6=Sab

      // Sábado → +2 días, Domingo a Viernes → +1 día
      const diasSumar = diaSemana === 6 ? 2 : 1;
      hoy.setDate(hoy.getDate() + diasSumar);

      const dia  = String(hoy.getDate()).padStart(2, '0');
      const mes  = String(hoy.getMonth() + 1).padStart(2, '0');
      const anio = hoy.getFullYear();

      return `${anio}-${mes}-${dia}`;             // ← Formato Laravel YYYY-MM-DD
    };
  }
};